import { Box } from '@mui/material';

import GamesSection from './Games';
import BannersSection from './Banners';
import AtlasWidget from './AtlasWidget';
import SoftSwissWidget from './SoftSwissWidget';
import PromotionsSection from './Promotions';
import HomeNavigationSection from './Navigation';
import PopularGames from './PopularGames';

import AttachFile from 'components/common/AttachFile';
import useWebsiteSports from 'store/websiteSports';
import useSettings, { IWebsiteConfigs } from 'store/settings';
import useScreen from 'hooks/useScreen';
import CategorySliderList from './CategorySliderList';
import TurboStarsWidget from './TurboStarsWidget';
import OneXBetWidget from './OneXBet';

const HomePage = () => {
  const [state] = useWebsiteSports();
  const [
    {
      data: { meta = {} as IWebsiteConfigs },
    },
  ] = useSettings();
  const { isMobile } = useScreen();

  const gamesSliderInfo = isMobile ? meta.gameSectionSlider?.mobile : meta.gameSectionSlider?.desktop;

  return (
    <Box className="content">
      <AttachFile />
      <BannersSection />
      {(!isMobile || meta.showMobileHomeNavigation) && <HomeNavigationSection />}
      {state.hasAtlasSport && <AtlasWidget />}
      {state.hasSoftSwissSport && <SoftSwissWidget />}
      {state.hasTurboStarsSport && <TurboStarsWidget />}
      {state.hasOneXBetSport && !meta?.hideOneXBetWidget && <OneXBetWidget />}
      {(!isMobile || meta.showMobilePopularGames) && <PopularGames />}
      {gamesSliderInfo ? <CategorySliderList {...gamesSliderInfo} /> : <GamesSection />}
      <PromotionsSection />
    </Box>
  );
};

export default HomePage;
